import FormField from "@ingka/form-field";

type Props = React.PropsWithChildren<{
  msg?: string;
}>;

export const Question = ({ msg, children }: Props) => (
  <FormField shouldValidate={!!msg} validation={{ msg }}>
    {children}
  </FormField>
);
